// https://material.angular.io/components/table/overview
import { Component, ViewChild, EventEmitter } from '@angular/core';
import { MatPaginator, MatDialog, MatSort } from '@angular/material';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/observable/merge';
import 'rxjs/add/operator/map';
import { generalService } from '../../services/general.service';
import { DataService } from '../../utils/data.service';
import { DataSourceGrid } from '../../utils/data-source-grid.component';
import { Cliente } from '../../models/cliente';

/**
 * @title Table with pagination
 */
@Component({
  selector: 'my-cliente-consultar',
  styleUrls: [], 
  templateUrl: 'cliente-consultar.component.html',
  providers: [generalService]
})
export class ClienteConsultarComponent {
  dataSource: DataSourceGrid | null;
  displayedColumns = ['acciones', 'razonSocial', 'rfc', 'telefono', 'municipio', 'estado'];
  public datosCliente:Array<any>;
  public cliente:Cliente;

  constructor(private _generalService: generalService, public dataService: DataService, public dialog: MatDialog) {
    this.datosCliente = new Array();
    this.cliente = new Cliente();
  }

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  consultarCliente(){
    let cliente = new Cliente();
    cliente.loacs = sessionStorage.getItem("acslo");
    this._generalService.metodoCallParams(cliente, "cliente/consultarClientes").subscribe(
      result => {
        this.datosCliente = JSON.parse(result);
        this.dataSource = new DataSourceGrid(this.datosCliente, this.paginator, this.sort);
        if(this.datosCliente.length <= 0)
          { $(".mat-row").remove(".mat-row"); }
        },
      error => {  console.log(<any>error);  }
    );
  }

  ngOnInit() {
    this.consultarCliente();
  }

   eliminarConfirm(cliente: Cliente){
    this.cliente.idCliente = cliente.idCliente;
    let eliminarHttp = new EventEmitter<any>();
    eliminarHttp.subscribe(
      (response: any) => {
         this.ngOnInit();
      }
    );
    this._generalService.modal(eliminarHttp, "confirm", "¿Desea eliminar el Cliente "+ cliente.Nombre +"?", "cliente/eliminarCliente/", this.cliente);
  }

}






// WEBPACK FOOTER //
// ./src/app/cliente/consultar-eliminar/cliente-consultar.component.ts